'use client';

import ActionButton from '../../../../components/form/ActionButton/ActionButton';
import LinkButton from '../../../../components/form/LinkButton/LinkButton';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import { Format } from '../../../../lib/dateFns';
import layoutStyles from '../../../../styles/modules/layout.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { formatDateCommon } from '../../../../utils/formatters';
import { LOTTERY_DRAW_TYPE, SHIPPING_OVER_TYPE } from '../../constants/index';
import type { LotteryDrawResult } from '../../types';
import styles from './CampaignLotteryDrawResultFooter.module.scss';

type Props = {
  lotteryDrawResult: LotteryDrawResult;
  onAddressInputClick: () => void;
  showModalParam: boolean; // trueの場合 ?showModal=true を付加
};

function CampaignLotteryDrawResultFooter({ lotteryDrawResult, onAddressInputClick, showModalParam }: Props) {
  return <div>{footer(lotteryDrawResult, onAddressInputClick, showModalParam)}</div>;
}

function footer(lotteryDrawResult: LotteryDrawResult, onAddressInputClick: () => void, showModalParam: boolean) {
  switch (lotteryDrawResult.shippingOver) {
    case SHIPPING_OVER_TYPE.reception.value:
      return <>{inputAddressReception(lotteryDrawResult, onAddressInputClick)}</>;
    case SHIPPING_OVER_TYPE.over.value:
      return <>{inputAddressOver()}</>;

    case SHIPPING_OVER_TYPE.ok.value:
      return <>{inputAddressOk(lotteryDrawResult, showModalParam)}</>;
  }
}

// 配送先情報未入力 && 入力期限内
function inputAddressReception(lotteryDrawResult: LotteryDrawResult, onAddressInputClick: () => void) {
  return (
    <>
      <div className={styles.title}>
        <p className={utilsStyles.textBold}>当選おめでとうございます！</p>
      </div>
      <div className={styles.description}>以下のボタンから景品の配送先情報を入力してください。</div>
      <div className={styles.notes}>
        <p>【注意事項】</p>
        <p>
          配送先情報の入力は
          {formatDateCommon(lotteryDrawResult.shippingEndDate, Format.dateTime)}
          までに完了してください。期間を超過すると当選が無効になります。
        </p>
      </div>
      <div className={`${utilsStyles.mtMedium} ${layoutStyles.centeredBtnWrapper}`}>
        <ActionButton outlined onClick={onAddressInputClick}>
          配送先情報を入力する
        </ActionButton>
      </div>
    </>
  );
}

// 配送先情報未入力 && 入力期限外
function inputAddressOver() {
  return (
    <>
      <div>
        <p className={`${utilsStyles.primaryColor} ${utilsStyles.textBold} ${utilsStyles.textCenter}`}>
          配送先情報の入力期間を超過したため、当選が無効となりました。
        </p>
      </div>
      <div className={`${utilsStyles.mtMedium} ${layoutStyles.centeredBtnWrapper}`}>
        <LinkButton outlined href='/'>
          トップページへ
        </LinkButton>
      </div>
    </>
  );
}

// 配送先情報入力済み
function inputAddressOk(lotteryDrawResult: LotteryDrawResult, showModalParam: boolean) {
  return (
    <>
      {lotteryDrawResult.drawType === LOTTERY_DRAW_TYPE.first_serial_code.value && (
        <div className={styles.induceText}>
          <p>
            キャンペーンくじに参加していただいた方限定で、
            <br />
            豪華景品が当たるハズレなし「スペシャルくじ」にチャレンジできます。
            <br />
            ※こちらは有料になります
          </p>
        </div>
      )}
      {lotteryDrawResult.lotteryEventBranchMissingImageUrl && (
        <div className={utilsStyles.mtMedium}>
          <ImageView src={lotteryDrawResult.lotteryEventBranchMissingImageUrl} alt='' isFreeSize />
        </div>
      )}
      <div className={`${utilsStyles.mtMedium} ${layoutStyles.centeredBtnWrapper}`}>
        {lotteryDrawResult.drawType === LOTTERY_DRAW_TYPE.first_serial_code.value ? (
          // 初回シリアルコードのみくじ
          <>
            <LinkButton color='primary' href={`/lotteries/${lotteryDrawResult.lotteryEventId}`}>
              スペシャルくじにチャレンジ
            </LinkButton>
            <LinkButton outlined href={`/campaign-lotteries/${lotteryDrawResult.lotteryEventBranchId}`}>
              シリアルコードでもう一度引く
            </LinkButton>
          </>
        ) : (
          // 初回シリアルコードのみくじ以外
          <>
            <LinkButton
              color='primary'
              href={`/campaign-lotteries/${lotteryDrawResult.lotteryEventBranchId}${showModalParam ? '?showModal=true' : ''}`}
            >
              シリアルコードでもう一度引く
            </LinkButton>
            <LinkButton outlined href={'/account/collection'}>
              獲得した景品一覧
            </LinkButton>
          </>
        )}
      </div>
    </>
  );
}

export default CampaignLotteryDrawResultFooter;
